import Vue from 'vue';

Vue.component('booking-today-modal', {
    data() {
        return {
            showModal: false,
        };
    },

    mounted() {
        this.$modals.$on('show-modal:booking-today', this.open);
    },

    methods: {
        open() {
            this.showModal = true;
        },

        close() {
            this.showModal = false;
        },
    },
});
